import { render, staticRenderFns } from "./RecruiterJobs.vue?vue&type=template&id=83ea6ca2&scoped=true"
import script from "./RecruiterJobs.vue?vue&type=script&lang=ts"
export * from "./RecruiterJobs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ea6ca2",
  null
  
)

export default component.exports